import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discover-six',
  templateUrl: './discover-six.component.html',
  styleUrls: ['./discover-six.component.css']
})
export class DiscoverSixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
